module.exports = __webpack_public_path__ + "price-analysis.svg?575ba34f304691cbbcbdbdeb89aa12bf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/price-analysis.svg
// module id = 95
// module chunks = 2